import type { AvatarConfig } from '@qq/shared';

/**
 * Every colour the original character art uses. Kept in one place so a skin
 * tone or a jersey colour is a data change, not a hunt through SVG paths.
 */

export const SKIN: Record<string, { base: string; shade: string }> = {
  sand: { base: '#f6dcc0', shade: '#e6c3a0' },
  honey: { base: '#efc79a', shade: '#dcae7c' },
  clay: { base: '#d99f74', shade: '#c2865c' },
  umber: { base: '#b87a4f', shade: '#9d6540' },
  cocoa: { base: '#8a5636', shade: '#734429' },
  ebony: { base: '#5c3822', shade: '#492b19' },
};

export const HAIR: Record<string, string> = {
  ink: '#2b2b33',
  chestnut: '#6b3f22',
  sand: '#d8b171',
  ginger: '#c25a26',
  silver: '#c9ccd1',
  berry: '#a8397a',
  ocean: '#2e7fa8',
};

export const BACKGROUND: Record<string, [string, string]> = {
  mint: ['#d8f0e4', '#a9dcc4'],
  sunrise: ['#ffe4c4', '#ffc48a'],
  lagoon: ['#d3ecf7', '#9ed3ea'],
  lilac: ['#e8ddf6', '#c9b3e8'],
  sand: ['#f6ecd8', '#e4d2b0'],
  reef: ['#cdeef0', '#79ccd2'],
};

export const OUTFIT: Record<string, { base: string; trim: string }> = {
  tee: { base: '#3f8f7d', trim: '#2f6f61' },
  stripes: { base: '#4a6fb5', trim: '#f2f4f8' },
  hoodie: { base: '#d1685c', trim: '#b04c42' },
  dress: { base: '#c05a92', trim: '#a24777' },
  jersey: { base: '#7b3fb5', trim: '#f2b134' },
  spacesuit: { base: '#dfe4ea', trim: '#7aa7d8' },
};

export const INK = '#2a2e2d';

export function skinOf(config: AvatarConfig) {
  return SKIN[config.skin] ?? SKIN.honey!;
}
export function hairOf(config: AvatarConfig) {
  return HAIR[config.hairColour] ?? HAIR.chestnut!;
}
export function backgroundOf(config: AvatarConfig) {
  return BACKGROUND[config.background] ?? BACKGROUND.mint!;
}
export function outfitOf(config: AvatarConfig) {
  return OUTFIT[config.outfit] ?? OUTFIT.tee!;
}
